import { GridRowParams } from '@mui/x-data-grid';

import { TelegramChatStatusesEnum } from '@shared/constants';
import { TelegramChatModel } from '@shared/types';

import styles from './TelegramChatSettingsTable.module.css';

const { processedDonationRow, closedDonationRow } = styles;

export const getTelegramChatRowClassName = (params: GridRowParams<TelegramChatModel>): string => {
  const {
    row: { status },
  } = params;

  switch (status) {
    case TelegramChatStatusesEnum.PROCESSED: {
      return processedDonationRow;
    }
    case TelegramChatStatusesEnum.CLOSED: {
      return closedDonationRow;
    }
    default: {
      return '';
    }
  }
};
